import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowUp, X } from 'lucide-react';

/**
 * SignupNudge — piccolo cartellino sotto il pulsante "Registrati/Accedi"
 * Visibile SOLO quando l'utente NON è loggato.
 * Sparisce dopo dismissal o dopo che l'utente clicca il pulsante.
 * `nudgeKey` = sessionStorage flag per evitare di mostrarlo ad ogni reload.
 */
export function SignupNudge({ onClick }) {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'it').split('-')[0];
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show only after a short delay so it doesn't compete with first paint
    const dismissed = (typeof window !== 'undefined') && window.sessionStorage?.getItem('signup_nudge_dismissed') === '1';
    if (dismissed) return;
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  const copy = {
    it: 'Registrati per non perderti le migliori offerte',
    de: 'Registrier dich, um keine Schnäppchen zu verpassen',
    fr: 'Inscrivez-vous pour ne rater aucune offre',
    en: 'Sign up to never miss a deal',
  };
  const dismiss = (e) => {
    e.stopPropagation();
    try { window.sessionStorage?.setItem('signup_nudge_dismissed', '1'); } catch { /* ignore */ }
    setVisible(false);
  };

  return (
    <div
      data-testid="signup-nudge"
      className="absolute right-0 top-full mt-2 z-50 hidden sm:flex items-start gap-1.5 animate-in fade-in slide-in-from-top-1 duration-300"
      style={{ pointerEvents: 'auto' }}
    >
      <div className="relative bg-amber-500 text-white text-[11px] font-semibold px-3 py-1.5 rounded-lg shadow-lg whitespace-nowrap flex items-center gap-2">
        {/* arrow up notch */}
        <ArrowUp size={12} className="absolute -top-2 right-4 text-amber-500 fill-amber-500 drop-shadow-sm" strokeWidth={3} />
        <button
          onClick={(e) => { e.stopPropagation(); onClick?.(); dismiss(e); }}
          className="hover:underline focus:outline-none"
        >
          {copy[lang] || copy.en}
        </button>
        <button
          onClick={dismiss}
          aria-label="dismiss"
          className="opacity-70 hover:opacity-100 -mr-1 p-0.5"
        >
          <X size={11} />
        </button>
      </div>
    </div>
  );
}
